import React, { useState } from 'react'
import { Box, IconButton, Grid, TextField } from '@material-ui/core'
import {
  ThumbsDown as ThumbsDownIcon,
  ThumbsUp as ThumbsUpIcon,
} from 'react-feather'

import { BaseDialog, Label, LoadingFeedback } from 'components'

import useSnackbar from 'hooks/useSnackbar'

import theme from 'theme'
import * as service from 'service'

const FeedbackDialog = ({
  open = false,
  setOpen = () => {},
  governanceProjectId,
  governanceProjectActivityId,
  daiResponseId,
}) => {
  const [feedback, setFeedback] = useState('')
  const [rate, setRate] = useState(null)
  const [loading, setLoading] = useState(null)

  const snackbar = useSnackbar()

  const handleSendFeedback = async () => {
    if (!rate) return

    setLoading(true)
    try {
      await service.dponet.governanceProjectActivity.daiAnalysisFeedback({
        governanceProjectId,
        governanceProjectActivityId,
        daiResponseId,
        params: {
          daiFeedback: {
            rate,
            reason: feedback,
          },
        },
      })

      snackbar.open({
        message: 'Feedback enviado com sucesso',
        variant: 'success',
      })
      setOpen(false)
    } catch (error) {
      snackbar.open({
        message: 'Ocorreu um erro ao enviar o feedback',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <BaseDialog
      open={open}
      setOpen={setOpen}
      title="Nos ajude a melhorar nosso assistente"
      dialogSize="sm"
      fullWidth
      closeButtonText="Cancelar"
      actionButtonText="Enviar"
      actionButton={handleSendFeedback}
      disableActionBtn={!rate}
    >
      <LoadingFeedback open={loading} />
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12}>
          <Label title="O que você achou da resposta?">
            <Box display="flex" gridGap={theme.spacing(1)}>
              <IconButton onClick={() => setRate('good')}>
                <ThumbsUpIcon
                  color={
                    rate === 'good' ? theme.palette.primary.main : undefined
                  }
                  strokeWidth={rate === 'good' ? 2.5 : 2}
                />
              </IconButton>
              <IconButton onClick={() => setRate('bad')}>
                <ThumbsDownIcon
                  color={
                    rate === 'bad' ? theme.palette.primary.main : undefined
                  }
                  strokeWidth={rate === 'bad' ? 2.5 : 2}
                />
              </IconButton>
            </Box>
          </Label>
        </Grid>

        <Grid item xs={12}>
          <Label title="O que você gostaria de ver melhorado?">
            <TextField
              fullWidth
              multiline
              minRows={3}
              maxRows={7}
              onChange={(e) => setFeedback(e.target.value)}
              variant="outlined"
            />
          </Label>
        </Grid>
      </Grid>
    </BaseDialog>
  )
}

export default FeedbackDialog
